var modules_a3dacc96 = {"list":"_1wfy4rg","ordered":"_uwkzkg _1wfy4rg","item":"_uvn4ce","unordered":"_1elezha _1wfy4rg","with-icon":"_1tcteps","icon":"_67eoze"};
import "../../../assets/Ccbhma1C.css";

export { modules_a3dacc96 as default };
//# sourceMappingURL=List.module.less.js.map
